<template>
  <div id="pageUploadPhotos" class="d-flex">
    <MainBarMenuV2 v-if="user.core_role_id > 10 && user.core_role_id < 20"/>
    <MainBarMenu v-if="user.core_role_id < 11 && user.core_role_id > 0"/>
    <div class="layout-content container-fluid">
      
      <heading-user />

      <!-- Gestión de la Información -->
      <header-v2 :title="'Gestión de la Información'"/>
      <!-- end -->

      <b-col cols="10" class="p-2 mx-auto">
        <nav-bar-v2 
          :items="itemsNavBar"> 
          <!-- Empleado -->
          <template v-slot:nav-empleados>
            <b-col cols="11" class="my-5">
              <h2 class="text-formatting-v2">
                <strong>
                  Fotografía de empleados
                </strong> 
              </h2>
              <p class="text-formatting-v2">
                Selecciona un máximo de 100 archivos de imagen para poder cargar dentro del sistema; 
                no olvides cumplir los requerimientos necesarios para evitar posibles inconvenientes.
              </p>

              <b-row>
                <!-- carga del archivo -->
                <b-col cols="12" sm="6">
                  <div class="alert alert-primary d-flex align-items-center with-border-v2 primary-v2">
                    <span class="icon icon-info text-primary mr-4"></span>
                    <p class="text-formatting-v2 p-0 m-0">
                      Carga de archivo <strong>Fotografía</strong> de empleados
                    </p>
                  </div>

                  <form id="file-upload-form" class="uploader">
                    <input 
                      id="photos" 
                      type="file"
                      @change="filesSelected"
                      accept=".jpg,.jpge"
                      multiple />

                    <label for="photos" id="file-drag" class="pointer">
                      <img 
                        id="file-image" 
                        src="@/assets/images/icons/ht_icon_upload.svg">
                      <div id="start">
                        <div class="text-formatting-v2">
                          <strong>
                            Arrastra aquí la imagen (fotografía del empleado)
                          </strong> 
                        </div>
                        <div class="text-formatting-v2">
                          JPG ó JPEG
                        </div>
                        <br>
                        <span id="photos-btn" class="button-v2 primary text-formatting-v2"> 
                          <strong>
                            Subir archivo
                          </strong>
                        </span>
                      </div>
                    </label>
                  </form>
                </b-col>
                <!-- end -->
                
                <!-- alerta de archivos permitidos -->
                <b-col cols="12" sm="6">
                  <div class="alert d-flex align-items-center with-border-v2 primary-v2">
                      <span class="icon icon-info text-primary mr-4"></span>
                      <p class="text-formatting-v2 p-0 m-0">El sistema solo recibe archivos de imagen en formato <b>JPG</b>  ó <b>JPEG</b>, con un peso máximo de <b>1Mb</b> por cada uno.
                      Para poder relacionar la fotografía a una persona, cada archivo requiere estar nombrado con el <b>número de identificación del empleado.</b></p>
                  </div>
                </b-col>
                <!-- end -->
              </b-row>
            </b-col>
            <b-col cols="12" class="my-5">
              <b-col> 
                <table-photo ref="table"/> 
              </b-col>
            </b-col>
          </template>
        </nav-bar-v2>
      </b-col>

    <!-- modal de subida de archivo -->
    <modal-confirmation 
      modal-id="modal-upload"
      includeLoader
      :processing="loading2"
      @click:accepted="saveFilesSelected">
        <template #body>
          <img class="col-4 my-3" src="@/assets/images/icons/ht_icon_upload_cloud_2_line.svg" />
          <p class="text-formatting-v2 h2-v2 text-center">
            <strong>
              Se cargarán {{ numberFiles }}  {{ numberFiles > 1 ? 'fotografías': 'fotografía' }} en segundo plano
            </strong> 
          </p>
            <p class="text-formatting-v2 text-center">
              Si hay alguna novedad en el proceso, te estaremos informando vía email. <br>
              Si deseas, puedes seguir cargando archivos de imagen.
            </p>
        </template>
        <template #buttonText>
          <strong>
            Entendido
          </strong>
        </template>
    </modal-confirmation>
    <!-- end -->

      
    <!-- modal para todo ok -->
    <modal-confirmation 
      modal-id="modal-success"
      v-if="message.success"
      @click:accepted="$bvModal.hide('modal-success')">
        <template #body>
          <img 
            class="col-4 my-3" 
            src="@/assets/images/icons/ht_icon_checkbox_circle_line.svg" />
          <p class="text-formatting-v2 h2-v2 text-center">
            <strong>
              ¡Proceso exitoso!
            </strong> 
          </p>
            <p class="text-formatting-v2 text-center">
              {{ message.result }}
            </p>
        </template>
        <template #buttonText>
          <strong>
            Entendido
          </strong>
        </template>
    </modal-confirmation>
    <!-- end -->
    

    <!-- Modal error -->
    <modal-confirmation 
      v-if="error.message || message.error_code"
      modal-id="modal-fail"
      @click:accepted="$bvModal.hide('modal-fail')">
        <template #body>
          <img 
            class="col-4 my-3" 
            src="@/assets/images/icons/ht_icon_close_circle_line.svg" />
          <p class="text-formatting-v2 h2-v2 text-center">
            <strong>
              ¡Proceso fallido!
            </strong> 
          </p>
            <p class="text-formatting-v2 text-center">
              {{ error.message ? error.message : message.message }}
            </p>
        </template>
        <template #buttonText>
          <strong>
            Entendido
          </strong>
        </template>
    </modal-confirmation>
    <!-- end -->
      
    </div>
  </div>
  <!-- #page-onboarding -->
</template>

<script>
import { mapActions, mapState } from "vuex";
import MainBarMenu from "@/components/layouts/MainBarMenu.vue";
import MainBarMenuV2 from "@/components/layouts/MainBarMenuV2.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
// import TablePhoto from "./tables/tablePhoto.vue"

export default {
  name: "HomeOnBoarding",
  components: {
    MainBarMenu,
    MainBarMenuV2,
    HeadingUser,
    TablePhoto: () => import('./tables/tablePhoto.vue'),
    NavBarV2: () => import('@/components/common/navs/NavBarV2.vue'),
    HeaderV2: () => import('../../components/common/header/HeaderV2.vue'),
    ModalConfirmation: () => import('../../components/common/modal/ModalConfirmation.vue')
  },
  data() {
    return {
      numberFiles: ''
    };
  },
  created() {
    this.actUser();
  },
  computed: {
    ...mapState("modCore", [
      "user",
      ]),
      ...mapState("modOhAnalyst", [
        "loading",
        "loading2",
        "error",
        "message",
        "tablePhoto",
        "tablePhone",
        "responsiblePhoto",
        "responsiblePhone",
        "employeeInfo",
        "employeesBySearch"
      ]),
    itemsNavBar () {
      return [
        {
          name: 'Empleados',
          path: 'nav-empleados'
        }
      ]
    }
  },
  methods: {
    ...mapActions("modCore", ["actGetOnboarding", "actUser"]),
    ...mapActions("modOhAnalyst",["actUploadImagesEmployees","actCheckEmployeesWithPhoto"]),
    filesSelected() {
        const dato = document.querySelector("#photos");
        this.numberFiles = dato.files.length;
        this.$root.$emit('bv::show::modal','modal-upload')
    },
    async saveFilesSelected(){
      const selector = document.querySelector("#photos")
      let images = new FormData()
      for (let index = 0; index < this.numberFiles; index++) { images.append('images[]',selector.files[index]) }
      await this.actUploadImagesEmployees(images)
      this.$root.$emit('bv::hide::modal','modal-upload')
      if (this.message.success) {
        this.$root.$emit('bv::show::modal','modal-success')
        this.$refs.table.loadRowsPhoto({ page: null })
      }
      if (this.error.message || this.message.error_code) { this.$root.$emit('bv::show::modal','modal-fail') }
    }
  },
};
</script>

<style lang="scss">
/** Carousel */
#uploadPhotos {

  .p2 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #1C3A4E;
    padding-left: 5%;
    text-align: justify;
  }

  #loader {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 1;
    width: 150px;
    height: 150px;
    margin: 150px 0 0 -75px;
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }

  @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  /* Add animation to "page content" */
  .animate-bottom {
    position: relative;
    -webkit-animation-name: animatebottom;
    -webkit-animation-duration: 1s;
    animation-name: animatebottom;
    animation-duration: 1s
  }

  @-webkit-keyframes animatebottom {
    from { bottom:-100px; opacity:0 }
    to { bottom:0px; opacity:1 }
  }

  @keyframes animatebottom {
    from{ bottom:-100px; opacity:0 }
    to{ bottom:0; opacity:1 }
  }

  #myDiv {
    display: none;
    text-align: center;
  }
  font-family: Open Sans;
    .responsible{
        background-color: #EEF2FA;
    }
    h4{
        font-weight: 600;
        font-size: 16px;
    }
    .alert{
        color:black;
    }
    .icon{
        font-size: 20px;
    }
    .regular{
        padding: 5px 15px;
        font-size: 16px;
        border-radius: 100px;
        background-color: white;
        border: 2px solid #269887;
        color: #269887;
    }
    .btn-create{
        padding: 12px;
        border-radius: 20px;
        background-color: #269887;
        border: none;
        color: white;
        display: flex;
        align-items: center;
        transition: 0.5s;

        span {
            font-size: 30px;
            line-height: 0;
            margin: 0 5px;
            font-weight: 500;
        }
    }
    .btn-create:hover{
        background-color: #27a391;
        box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);
    }
    .check-status{
        .status{
        padding: 5px 10px;
        border-radius: 20px;
        font-size: 14px;
        }
    }
    
}

</style>